/* global module require */
const lib = require('./tv_base.js');
lib.newsletters = require('../tv_newsletters/newsletters.ts');
module.exports = lib;
